import uuid from 'uuid/v1'

import * as createConst from '../../../../constants/General/GoogleAPI'
import { updateTab , addActionInTab} from "../../../Tabs"
import {objToArr} from '../../../../utilities'
import {openDialog} from '../../../openDialog'

export const addCreateEvent = (parentId = null) => {
          return (dispatch, getState) => {
            let { tabs, currentTab } = getState()
            let tab = tabs[currentTab]
            let action = {
              id : uuid(),
              type : createConst.CREATE_EVENT,
              parentId : parentId,
              label : "Create Event",
              key : "createevent",
              allowNesting : false,
              variableName : '',
              instruction : "",
              description : "",
              status:false,
              breakpoint:false
            }
            let apiConfig =  objToArr(tab.actions).find((action)=>{
              return tab.actions[action.id].type == 'API_CONFIGURATION'
              })          
              if(apiConfig){
                tab =  addActionInTab(tab,action,parentId)
                dispatch(updateTab(tab))
              }else{
                dispatch(openDialog("api",action))
              }
          }
}
export const editCreateEvent= (payload, actionId=null) => {
          return (dispatch, getState) => {
            let { tabs, currentTab } = getState()
            let tab = tabs[currentTab]
            let createEventAction = tab["actions"][actionId ? actionId : tab.currentAction]
            let temp = {
                ...createEventAction,
              ...payload
            }
            temp.status = (temp.starttime!=""&&temp.starttime!=undefined) && (temp.endtime!=""&&temp.endtime!=undefined) && (temp.attendees!=""&&temp.attendees!=undefined) && (temp.timezone!=""&&temp.timezone!=undefined)
            && (temp.location!=""&&temp.location!=undefined)
            
            tab["actions"][actionId ? actionId : tab.currentAction] = {
              ...temp,
              instruction : `create event`,
              description : `create event`
            }
            dispatch(updateTab(tab))
          }
        }
        